module.exports = __webpack_public_path__ + "img/icon-supervisor-default-avatar.62237293.png";